// extracted by css-extract-rspack-plugin
export default {"disc":"bvFBVL"};